import { AxiosInstance } from 'axios';

import * as types from '../../../../../../../typings/api/integrations/leica/rest/v1/auth';

export class AuthServiceV1 implements types.Handlers {
  private readonly endpoint = '/v1/auth';

  constructor(private axios: AxiosInstance) {}

  async getSignInUrl(params: types.GetSignInUrlParameters): Promise<types.GetSignInUrlResponse> {
    const { data } = await this.axios.get<types.GetSignInUrlResponse>(
      `${this.endpoint}/sign-in/url`,
      {
        params: params.query,
      },
    );
    return data;
  }

  onSignInSuccess(params: types.OnSignInSuccessParameters): Promise<void> {
    throw new Error('Method not implemented.');
  }
}
